import {Translate} from "components/common/Translate/Translate";
import {ZipIcon} from "components/common/Icons/ZipIcon";
import {LightningFastIcon} from "components/common/Icons/LightningFastIcon";
import {PrivacyGuaranteedIcon} from "components/common/Icons/PrivacyGuaranteedIcon";
import {HeartIcon} from "components/common/Icons/HeartIcon";
import {ContentParent} from "components/modules/Content/ContentParent";
import {ContentItem} from "components/modules/Content/ContentItem/ContentItem";
import {BadgeIcon} from "components/common/Icons/BadgeIcon";
import {ImageFormatsIcon} from "components/common/Icons/ImageFormatsIcon";
import {Award, FileStack, HeartHandshake, PencilRuler, ShieldCheck, ShieldCheckIcon, Zap} from "lucide-react";

export const JpegCompressorFeaturesContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-quality-title" />}
                description={<Translate keyName="content-quality-sub-title" />}
                icon={<Award strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-free-title" />}
                description={<Translate keyName="content-free-sub-title" />}
                icon={<HeartHandshake strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-fast-delivery-title" />}
                description={<Translate keyName="content-fast-delivery-sub-title" />}
                icon={<Zap strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="content-no-expertise-title" />}
                description={<Translate keyName="content-no-expertise-sub-title" />}
                icon={<PencilRuler strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="content-privacy-title" />}
                description={<Translate keyName="content-privacy-sub-title" />}
                icon={<ShieldCheck strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-bulk-compression-title" />}
                description={<Translate keyName="content-bulk-compression-sub-title" />}
                icon={<FileStack strokeWidth={1.5} width={30} height={30}/>}
            />
        </ContentParent>
    );
};
